export function renderDiagram(ctx, shape, ptScale) {
    const x = shape.position.x * ptScale;
    const y = shape.position.y * ptScale;
    const width = shape.size.width * ptScale;
    const height = shape.size.height * ptScale;
    ctx.fillStyle = '#f8f9fa';
    ctx.fillRect(x, y, width, height);
    ctx.strokeStyle = '#4472C4';
    ctx.lineWidth = 2;
    ctx.strokeRect(x, y, width, height);
    const centerX = x + width / 2;
    const centerY = y + height / 2;
    const boxSize = Math.min(width, height) * 0.15;
    const spacing = boxSize * 0.5;
    const boxes = [
        { x: centerX - boxSize - spacing, y: centerY - boxSize / 2 },
        { x: centerX + spacing, y: centerY - boxSize / 2 },
        { x: centerX - boxSize / 2, y: centerY + spacing },
    ];
    ctx.strokeStyle = '#4472C4';
    ctx.lineWidth = 2;
    boxes.forEach((box1, i) => {
        boxes.forEach((box2, j) => {
            if (i < j) {
                ctx.beginPath();
                ctx.moveTo(box1.x + boxSize / 2, box1.y + boxSize / 2);
                ctx.lineTo(box2.x + boxSize / 2, box2.y + boxSize / 2);
                ctx.stroke();
            }
        });
    });
    ctx.fillStyle = '#4472C4';
    boxes.forEach((box) => {
        ctx.fillRect(box.x, box.y, boxSize, boxSize);
    });
    ctx.fillStyle = '#333333';
    ctx.font = `${14 * ptScale}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText('SmartArt / Diagram', centerX, y + height - 30 * ptScale);
}
//# sourceMappingURL=diagram.js.map